import { from } from "rxjs";
import { switchMap, take } from "rxjs/operators";
import { selectBuildingInfoByTypeId } from "../../../../selectors/selectExistingBuildingInfo";
import { selectActiveTutorialConfig } from "../../../../selectors/selectTutorial";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionViewportCenterOn, actionViewportClearCenter } from "../../../viewport/actionViewport";
export var pathFocusOnBuilding = function (action, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(take(1), switchMap(function (viewport) {
        var state = state$.value;
        var tutorialConfig = selectActiveTutorialConfig(state);
        var building = selectBuildingInfoByTypeId(state, tutorialConfig.buildingId);
        var origin = utilBuildings.getCenterPositionOnScreen(building, viewport);
        return from([actionViewportClearCenter(), actionViewportCenterOn(origin)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/path/pathFocusOnBuilding.ts
// module id = 2473
// module chunks = 3